import { SlashMenuConfigExtension } from '@blocksuite/hive-widget-slash-menu';
import { BlockViewExtension } from '@blocksuite/std';
import type { ExtensionType } from '@blocksuite/store';
import { literal } from 'lit/static-html.js';

import { LatexBlockAdapterExtensions } from './adapters/extension.js';
import { latexSlashMenuConfig } from './configs/slash-menu.js';

export const LatexBlockSpec: ExtensionType[] = [
  BlockViewExtension('hive:latex', literal`hive-latex`),
  LatexBlockAdapterExtensions,
  SlashMenuConfigExtension('hive:latex', latexSlashMenuConfig),
].flat();
